import { wixServerData } from '../utils/wixServerData';
const FALLBACK_LOCALE = 'en';
const TRANSLATIONS_SERVERLESS_ENDPOINT = '/_api/premium-package-pickers-api/translations';
const fetchLocale = async (baseUrl, locale) => {
  const response = await fetch(`${baseUrl}/assets/locale/messages_${locale}.json`);
  if (!response.ok) {
    throw new Error(`Failed to fetch translations for locale "${locale}": HTTP ${response.status}`);
  }
  return response.json();
};
const fetchTranslationsFromServerless = async locale => {
  try {
    const response = await fetch(`${TRANSLATIONS_SERVERLESS_ENDPOINT}?locale=${encodeURIComponent(locale)}`);
    return response.ok ? response.json() : {};
  } catch {
    return {};
  }
};
const fetchTranslations = async locale => {
  const {
    translationsBaseUrl
  } = wixServerData.get();
  if (!translationsBaseUrl) {
    return fetchTranslationsFromServerless(locale);
  }
  try {
    return await fetchLocale(translationsBaseUrl, locale);
  } catch {
    if (locale === FALLBACK_LOCALE) {
      return {};
    }
    return fetchLocale(translationsBaseUrl, FALLBACK_LOCALE).catch(() => ({}));
  }
};

// Several module providers load the same namespace per page; memoize per locale
// to keep it a single request.
const cache = new Map();
export const loadPackagePickerTranslations = locale => {
  const cached = cache.get(locale);
  if (cached) {
    return cached;
  }
  const promise = fetchTranslations(locale);
  cache.set(locale, promise);
  return promise;
};
//# sourceMappingURL=loadTranslations.js.map